<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-11-19 11:01:28
 * @LastEditTime: 2020-09-24 10:01:10
 * @LastEditors: duiying
 -->
<template>
  <div class="categroy-nav-view root-box" :class="{ showNavBar }">
    <!-- 导航栏 -->
    <search-item :pageId="pageId"></search-item>
    <!-- 主内容区 -->
    <div class="container">
      <!-- 左侧菜单栏 -->
      <nav-item :pageId="pageId"></nav-item>
      <!-- 右侧商品区 -->
      <!-- <category-item :pageId="pageId" ></category-item> -->
      <category-right :pageId="pageId" />
    </div>
    <!-- 分享sheet -->
    <share-sheet-box />
  </div>
</template>

<script>
import { YjPerformance } from '@yunji/report'
import YunJi from '@/assets/js/YunJi'
import SearchItem from './components/SearchItme.vue'
import NavItem from './components/NavItem.vue'
import CategoryRight from './CategoryRight'
import shareSheetBox from './components/shareSheetBox'

export default {
  components: {
    SearchItem,
    NavItem,
    CategoryRight,
    shareSheetBox
  },
  data() {
    return {
      appCont: YunJi.getUrlParams('appCont'),
      shopId: YunJi.getUrlParams('shopId'),
      showNavBar: YunJi.showNavBar(),
      pageId: '00159'
    }
  },
  created() {
    if (this.appCont == 1) {
      this.pageId = '10294'
    } else if (this.appCont == 2) {
      this.pageId = '20152'
    }
  },
  mounted() {
    const pusherShopIdStorage = (sessionStorage && sessionStorage.getItem('pusherShopId')) || ''
    if (!pusherShopIdStorage && this.shopId && this.appCont != 7) {
      sessionStorage && sessionStorage.setItem('pusherShopId', this.shopId)
    }

    try {
      YjPerformance({ pageid: 10014 })
    } catch (err) {
      console.log(err)
    }
    this.initLoadThinkingReport()
  },
  methods: {
    // 数数初始化加载页面的埋点
    initLoadThinkingReport() {
      window.thinkingReport.track('page_load', {
        page_id: this.pageId
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/common.less';
.categroy-nav-view{
  .container{
    box-sizing: border-box;
    display: flex;
    flex: 1;
    height: calc(100% - 0.92rem);
    padding-top: 0.24rem;
    background-color: #f2f2f2;
  }
}
</style>
<style>
html,body,#main{
  height: 100%;
}
::-webkit-scrollbar{
  width: 0;
}
::-webkit-scrollbar-thumb{
  width: 0;
}
</style>
